import { React } from "react";
import "../components/styles/about.css";
import QuickIntro from "./quickIntro";
import { Link } from "react-router-dom";

function about() {
  return (
    <div className="container-about">
      <QuickIntro />
      <div className="about">
        <h1 className="self">Self!</h1>
        <p className="about-text">
          A software engineer by profession with a passion for building
          purposeful technology. By day, I build scalable{" "}
          <b className="bold">software applications</b>, and beyond the 9-to-5,
          I focus on creating meaningful digital solutions that leave a lasting
          impact.  I'm also an  <b className="bold">AI enthusiast with a keen eye for SaaS product development. </b><br />
          <br />
          With over three years of experience in software development, I
          specialize in web app development, wireframing, project planning, and
          negotiation (because tech without communication is just chaos). I’m
          obsessed with solving real-world problems through clean, purposeful
          technology that reduces human effort and adds genuine value.
          <br /> <br />
          My mission? To build tech that matters and help brands rise above the
          noise —{" "}
          <b className="bold">one pixel and one line of code at a time.</b>
        </p>
        <h1 className="self">Previously...</h1>
        <p className="about-text">
          I started out in architecture, never imagining I’d end up in tech. But
          after switching to computer science and writing my first “Hello,
          World,” everything clicked. Born in{" "}
          <b className="bold">Dammam, Saudi Arabia,</b> and raised in{" "}
          <b className="bold"> India</b>, now building at the crossroads of
          creativity and code.
        </p>
        <Link
          to="/usermanual"
          className="more"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          More about me ⟶
        </Link>
      </div>
    </div>
  );
}

export default about;
